// extracted by mini-css-extract-plugin
module.exports = {"product-media":"Media_product-media__wJ7zE"};